const ProjectSearchFR = {
    label                 : '💡 Essayez : table, comptoir de bar, escalier...',
    placeholder           : 'Ex : verrière, terrasse, agencement...',
    noOptionLabel         : 'Aucun résultat',
    topSearchedProjects   : 'Projets populaires',
    otherSearchedProjects : 'Autres projets',
};

export default ProjectSearchFR;
